import type { UnitSystem } from '@openrocket-web/physics';
import type { Action } from '../state/app';
import type { Theme } from '../state/persist';

interface Props {
  readonly units: UnitSystem;
  readonly theme: Theme;
  readonly dispatch: (a: Action) => void;
}

/** Contenido del diálogo «Preferencias»: sistema de unidades y tema. */
export function Preferences({ units, theme, dispatch }: Props): JSX.Element {
  return (
    <>
      <fieldset className="units">
        <legend>Sistema de unidades</legend>
        {(['metric', 'imperial'] as const).map((u: UnitSystem) => (
          <label key={u}>
            <input type="radio" name="units" value={u} checked={units === u} onChange={() => dispatch({ type: 'units', units: u })} />
            {u === 'metric' ? 'Métrico' : 'Imperial'}
          </label>
        ))}
      </fieldset>
      <fieldset className="units">
        <legend>Tema</legend>
        {(['dark', 'light'] as const).map((t: Theme) => (
          <label key={t}>
            <input type="radio" name="theme" value={t} checked={theme === t} onChange={() => dispatch({ type: 'theme', theme: t })} />
            {t === 'dark' ? 'Oscuro' : 'Claro'}
          </label>
        ))}
      </fieldset>
    </>
  );
}
